import React from 'react';
import * as consts from '../../models/consts.js'
import CampaignDetailsPlayOld from './CampaignDetailsPlayOld.jsx';
import CampaignSummaryPlayOld from './CampaignSummaryPlayOld.jsx';
import QueryStringService from '../../services/queryStringService.js';
import CampaignSummaryPlay from './CampaignSummaryPlay.jsx';
import CampaignDetailsPlay from './CampaignDetailsPlay.jsx';
import PanelService from '../../services/panelService';

export default class CampaignInfoPlay extends React.Component {
    constructor() {
        super();
        this.queryStringService = new QueryStringService();
        this.country = this.queryStringService.getCurrentCountry();
        this.state = {
        };
    }

    shouldShow() {
        return Array.from(arguments).includes(this.country);
    }

    validateOrderlineAgainstExceptionList(orderline) {
        if (this.props.orderData.orderlinesExceptionsForce5SecVacValues) {
            if (this.props.orderData.orderlinesExceptionsForce5SecVacValues.includes(parseInt(orderline))) {
                return true
            }
            if (this.props.orderData.orderlinesExceptionsForce5SecVacValues.includes(orderline)) {
                return true
            }
        }
        return false
    }

    render() {
        // this fix is needed to keep backward compatibility for campaigns that ended before the fix, since those will have to stay unchanged
        // the issue is related only to fxp campaigns since instead of using the VACSOV to to calculate delivered % it used the total one.
        let shouldUseFxpDeliveryFix = false;
        let no97Fxp = false;
        let selectedDetailsData = this.props.selectedDetailsData
        let spotlength = '';
        if (this.props.selectedDetailsData.spotlengths){
            if (this.props.selectedDetailsData.spotlengths.length > 1){
                spotlength = 'mixed'
            }
            else if (this.props.selectedDetailsData.spotlengths.length > 0){
                spotlength = this.props.selectedDetailsData.spotlengths[0];
            }
        }
        let extraValueLabel = ''
        let extraValueValue = 0
        let orderlineInExceptionList = this.validateOrderlineAgainstExceptionList(this.props.selectedOrderLines[0].id)
        let useNewSoVCalculation = moment(this.props.campaignInfo.periodStart).format('YYYY-MM-DD') >= moment(this.props.parameters.clientSettings.newSOVCalculationFrom).format('YYYY-MM-DD');

        switch (this.props.campaignPackagePromise) {
            case consts.CampaignPromisePackings.sov:
                const targetSov = this.props.selectedOrderLines[0].targetSoV;
                const sov = this.props.campaignInfo.soV;

                extraValueLabel = 'Contacts' + (this.shouldShow(consts.Countries.se) ? '**' : '' );
                let idsVac = this.props.campaignInfo.idsVac
                let idsTarget = this.props.campaignInfo.idsTargetRaw

                if (idsVac != 0 && idsVac != 'null' &&
                    idsTarget != 0 && idsTarget != 'null' &&
                    sov != 0 && sov != 'null' &&
                    targetSov != 0 && targetSov != 'null')
                    {
                        extraValueValue = parseInt(((this.props.selectedData.target / idsTarget ) * idsVac ) - idsTarget) // (( AIDA Promised VAC / IDS Promised VAC ) * Broadsign Delivered VAC (5 sec) ) – IDS Promised VAC <- from Moa
                }
                break;

            case consts.CampaignPromisePackings.fxp:
                extraValueLabel = 'VAC Contacts' + (this.shouldShow(consts.Countries.se,consts.Countries.no) ? '*' : '' );
                let cutoffDate = this.props.parameters.clientSettings.fxpWrongDeliveryCutoffDate;
                shouldUseFxpDeliveryFix = Date.parse(this.props.selectedOrderLines[0].periodEnd) >= Date.parse(cutoffDate);
                //fxp without 97% rule only used in SE for now
                if (this.country == consts.Countries.se) {
                    let no97PercCutoffDate = this.props.parameters.clientSettings.fxpNo97PercentCutoffDate;
                    no97Fxp = Date.parse(this.props.selectedOrderLines[0].confirmationDate) >= Date.parse(no97PercCutoffDate);
                }
                if (shouldUseFxpDeliveryFix && !no97Fxp) {
                    let soVScreens = PanelService.getPanelsThatMatchesTargetSoV(this.props.selectedOrderLines[0].targetSoV, this.props.parameters.playSuccessLimit / 100.0,
                        this.props.parameters.soVNumberOfDecimals, this.props.selectedData.panels, useNewSoVCalculation);
                    let vacContacts = soVScreens.reduce((acc, val) => { return acc + val.deliveredDouble; }, 0).toFixed(0);
                    extraValueValue = vacContacts - this.props.selectedOrderLines[0].targetVAC
                } else {
                    extraValueValue = this.props.campaignInfo.vacContacts - this.props.selectedOrderLines[0].targetVAC
                }
                break;

            case consts.CampaignPromisePackings.vac:
                extraValueLabel = 'VAC Contacts' + (this.shouldShow(consts.Countries.se,consts.Countries.no) ? '*' : '' );
                extraValueValue = this.props.campaignInfo.vacContacts - this.props.selectedOrderLines[0].targetVAC
                break;

            case consts.CampaignPromisePackings.sfi:
                extraValueLabel = 'Plays'
                extraValueValue = this.props.campaignInfo.plays - this.props.selectedOrderLines[0].targetPlays
                break;
            default:
                break;
        }


        return (
            <div className="row campaign-info">
            {this.props.useOldPlay &&
                <div className="col-sm-6 col-sm-push-6 col-md-4 col-md-push-8 campaign-summary-container" align="center">
                    <CampaignSummaryPlayOld
                        selectedCampaignType={this.props.selectedCampaignType}
                        selectedData={this.props.selectedData}
                        selectedDataType={this.props.selectedDataType}
                        onSelectDataType={(dataType) => this.props.onSelectDataType(dataType)}
                        campaignInfo={this.props.campaignInfo}
                        contactsLabel={this.props.contactsLabel}
                        parameters={this.props.parameters}
                        spotlength={spotlength}
                        selectedOrderLines={this.props.selectedOrderLines}
                        selectedDetailsData={selectedDetailsData}
                        orderlineInExceptionList={orderlineInExceptionList}
                        useAlternateContacts={this.props.useAlternateContacts}/>
                </div>
            }
            {this.props.useOldPlay &&
                <div className="col-sm-6 col-sm-pull-6 col-md-8 col-md-pull-4">
                    <CampaignDetailsPlayOld
                        campaignInfo={this.props.campaignInfo}
                        orderData={this.props.orderData}
                        campaignName={this.props.campaignName}
                        periodManuallySelected={this.props.periodManuallySelected}
                        selectedCampaignType={this.props.selectedCampaignType}
                        selectedData={this.props.selectedData}
                        selectedDataType={this.props.selectedDataType}
                        selectedDetailsData={selectedDetailsData}
                        selectedOrderLines={this.props.selectedOrderLines}
                        parameters={this.props.parameters}
                        spotlength={spotlength}
                        orderlineInExceptionList={orderlineInExceptionList}
                        useAlternateContacts={this.props.useAlternateContacts}/>
                </div>
            }
            {!this.props.useOldPlay &&
                <div className="col-sm-6 col-sm-push-6 col-md-6 col-md-push-6 campaign-summary-container" align="center">
                    <CampaignSummaryPlay
                        selectedCampaignType={this.props.selectedCampaignType}
                        dataFetchedInUTC={this.props.orderData.dataFetchedInUTC}
                        campaignName={this.props.campaignName}
                        selectedData={this.props.selectedData}
                        selectedDataType={this.props.selectedDataType}
                        onSelectDataType={(dataType) => this.props.onSelectDataType(dataType)}
                        campaignInfo={this.props.campaignInfo}
                        contactsLabel={this.props.contactsLabel}
                        parameters={this.props.parameters}
                        spotlength={spotlength}
                        campaignPackagePromise={this.props.campaignPackagePromise}
                        selectedOrderLines={this.props.selectedOrderLines}
                        extraValueValue={extraValueValue}
                        useAlternateContacts={this.props.useAlternateContacts}
                        shouldUseFxpDeliveryFix={shouldUseFxpDeliveryFix}
                        no97Fxp={no97Fxp}/>
                </div>
            }
            {!this.props.useOldPlay &&
                <div className="col-sm-6 col-sm-pull-6 col-md-pull-6 col-md-6" style={{'paddingBottom': '20px'}}>
                    <CampaignDetailsPlay
                        campaignInfo={this.props.campaignInfo}
                        orderData={this.props.orderData}
                        campaignName={this.props.campaignName}
                        periodManuallySelected={this.props.periodManuallySelected}
                        selectedCampaignType={this.props.selectedCampaignType}
                        selectedData={this.props.selectedData}
                        selectedDataType={this.props.selectedDataType}
                        selectedDetailsData={selectedDetailsData}
                        parameters={this.props.parameters}
                        spotlength={spotlength}
                        selectedOrderLines={this.props.selectedOrderLines}
                        campaignPackagePromise={this.props.campaignPackagePromise}
                        extraValueValue={extraValueValue}
                        extraValueLabel={extraValueLabel}
                        useAlternateContacts={this.props.useAlternateContacts}/>
                </div>
            }
            </div>
        );
    }
}